const ALL_MOBILE_WARNING_MESSAGE_BOX_TYPES = ['pwa-warning', 'mobile-beta-warning'];
export function isMobileWarningMessageBoxType(val) {
    if (!val) {
        return false;
    }
    return ALL_MOBILE_WARNING_MESSAGE_BOX_TYPES.includes(val);
}
